import styles from './styles/ScrollableContainer.module.scss';
import React, { useRef } from 'react';
import { useScrollbar } from '../../hooks/useScrollbar';
const ScrollbarSlider = ({ hostRef, scrollbarClassName }) => {
    const { scrollbarHidden, scrollbarSliderTop, scrollbarSliderHeight } = useScrollbar(hostRef);
    if (scrollbarHidden)
        return null;
    return (React.createElement("div", { className: `pos:a z:3 t:0 b:0 trs:all:300 ${styles.scrollbar} ${scrollbarClassName !== undefined ? scrollbarClassName : ''}` },
        React.createElement("div", { className: `pos:a l:0 w:100 ${styles.scrollbarSlider}`, style: { height: `${scrollbarSliderHeight}%`, top: `${scrollbarSliderTop}%` } })));
};
export const ScrollableContainer = ({ className, scrollbarClassName, children }) => {
    const hostRef = useRef(null);
    return (React.createElement("div", { className: `pos:r ${styles.container} ${className !== undefined ? className : ''}` },
        React.createElement("div", { ref: hostRef, className: "h:100 ov:x:h ov:y:a scrbar:none" }, children),
        React.createElement(ScrollbarSlider, { hostRef: hostRef, scrollbarClassName: scrollbarClassName })));
};
